import {LabelWithoutJson} from '@/components/atoms'
import {PageContainer} from '@/components/organisms'
import {extractLanguageValues} from '@/helpers/shadcn/utils'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {COLOR_CODE} from '@/utils/constants/colors'
import {FONT_WEIGHT} from '@/utils/constants/globalStyle'

const BrandAndCategory = ({productData}) => {
  const languages = useFeatureFlagLanguages()

  const LabelWithVal = ({keyName, val}) => {
    const id = keyName?.toLowerCase()?.replaceAll(' ', '_') ?? ''
    return (
      <div className="col-4 pt-5">
        <div className="w-49">
          <LabelWithoutJson id={`${id}_label`} text={keyName} />
        </div>
        <div className="w-49">
          <LabelWithoutJson
            id={`${id}_value`}
            text={val}
            isValueDiasbledInput={false}
            fontWeight={FONT_WEIGHT.BOLD}
            color={COLOR_CODE._FFFFFF}
          />
        </div>
      </div>
    )
  }
  const catogeriesString = productData?.category?.categories?.map(item => item.categoryName).join(', ')
  return (
    <PageContainer>
      <div className="productoverview-brand-category">
        {/* Brand Content */}
        <div className="sc-border heading mt-[29px] pb-5 text-base font-bold">Brand Information</div>
        <div className="sc-border grid grid-cols-3 gap-4 pb-5">
          <LabelWithVal keyName="Brand" val={productData?.brandInfo?.brand?.en || '-'} />
          <LabelWithVal keyName="Display Brand ID" val={productData?.brandInfo?.displayBrandId || '-'} />
          <LabelWithVal keyName="Brand Group Name" val={productData?.brandInfo?.brandGroupName || '-'} />
          <LabelWithVal keyName="Sub Brand ID" val={productData?.brandInfo?.subBrandId || '-'} />
          <LabelWithVal keyName="Product Brand " val={productData?.brandInfo?.brand?.en || '-'} />
          <LabelWithVal keyName="Brand ID" val={productData?.brandInfo?.brandId || '-'} />
        </div>
        {languages.map(lang => (
          <div key={lang?.code}>
            <div className="language-wrapper pt-5">
              <span>Language:</span> {lang?.language}
            </div>
            <div className="sc-border grid grid-cols-3 gap-4 pb-5">
              <LabelWithVal keyName="Display Brand" val={productData?.brandInfo?.displayBrand?.[lang?.code] || '-'} />
              <LabelWithVal keyName="Product Sub brand" val={productData?.brandInfo?.subBrand?.[lang?.code] || '-'} />
            </div>
          </div>
        ))}
        {/* Category Content */}
        <div className="sc-border heading mt-[29px] pb-5 text-base font-bold">Category Information</div>
        <div className="sc-border grid grid-cols-3 gap-4 pb-5">
          <LabelWithVal keyName="ERP Category" val={productData?.category?.erpCategory || '-'} />
          <LabelWithVal keyName="ERP Category ID" val={productData?.category?.erpCategoryId || '-'} />
          <LabelWithVal keyName="Category Type" val={productData?.category?.categoryType || '-'} />
        </div>
        <div className="sc-border width-full flex flex-col gap-4 pb-5">
          <div className="width-full">
            <LabelWithVal keyName="Display Category ID" val={productData?.category?.displayCategoryId || '-'} />
          </div>
          <div className="grid grid-cols-3">
            {languages.map(lang => (
              <div className="w-49" key={lang?.code}>
                <div className="language-wrapper pt-5">
                  <span>Language:</span> {lang?.language}
                </div>
                <div className=" gap-4 pb-5">
                  <LabelWithVal
                    keyName="Display Category"
                    val={productData?.category?.displayCategory?.[lang?.code] || '-'}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <LabelWithVal keyName="Sub Category" val={(productData?.category?.subCategoryFlag ? 'Yes' : 'No') || '-'} />
        {productData?.category?.subCategoryFlag &&
          productData?.category?.subCategories?.map(item => (
            <>
              <LabelWithVal keyName="Display Sub Category ID" val={item?.code || '-'} />

              <div key={item?.code} className="grid grid-cols-3  pt-2">
                {languages?.map(lang => (
                  <div className="width-full" key={lang?.code}>
                    <div className="language-wrapper pt-3">
                      <span>Language:</span> {lang?.language}
                    </div>
                    <div className=" gap-4 pb-2">
                      <LabelWithVal
                        keyName="Sub Category "
                        val={item?.values ? item?.values[lang?.code] || '-' : '-'}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          ))}
      </div>
    </PageContainer>
  )
}

export default BrandAndCategory
